import { useMemo } from "react";
import { useSession } from "../store/session";
import { withChatActivity } from "./approvalReviewState";

/** Attention summaries with the live chat state folded in (see withChatActivity). */
export function useLiveAttention() {
  const attention = useSession(s => s.attentionByCompany);
  const status = useSession(s => s.sessionStatusByCompany);
  return useMemo(() => withChatActivity(attention, id => status[id]?.state === "running" && status[id]?.busy === true),
    [attention, status]);
}
